export enum UserRoles {
  NOTARY_USERS_ROLE = 'Notary_Users',
  EOEA_USERS_ROLE = 'EOEA_Users',
  ADMIN_USERS_ROLE = 'Admin_Users',
  GLOBAL_USERS_ROLE = 'Global_Users',
  GUEST_USERS_ROLE = 'Guest_Users',
  ALL = 'All',
}
